import PropTypes from "prop-types";

import Button from "@shared/v2/Button";
import { PhoneSolidV6, ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import { STYLES } from "../../common";

const ActivityBtns = ({ callHandlr, listingHandlr, reportHandlr, containerClassName }) => (
  <div className={`${STYLES.btnContainer} ${containerClassName}`}>
    {callHandlr && (
      <Button
        schema="secondary"
        className={`${STYLES.btn} tw-w-[56px]`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          callHandlr();
        }}
      >
        <PhoneSolidV6 size="s" />
        <span>CALL</span>
      </Button>
    )}
    {listingHandlr && (
      <Button
        schema="secondary"
        className={`${STYLES.btn} tw-w-[102px]`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          listingHandlr();
        }}
      >
        <ArrowUpRightFromSquareSolidV6 size="s" />
        <span>VIEW LISTING</span>
      </Button>
    )}
    {reportHandlr && (
      <Button
        schema="secondary"
        className={`${STYLES.btn} tw-w-[102px]`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          reportHandlr();
        }}
      >
        <ArrowUpRightFromSquareSolidV6 size="s" />
        <span>VIEW REPORT</span>
      </Button>
    )}
  </div>
);

export default ActivityBtns;

ActivityBtns.propTypes = {
  callHandlr: PropTypes.func,
  listingHandlr: PropTypes.func,
  reportHandlr: PropTypes.func,
  containerClassName: PropTypes.string,
};

ActivityBtns.defaultProps = {
  callHandlr: null,
  listingHandlr: null,
  reportHandlr: null,
  containerClassName: "",
};
